import * as moment from "moment"
require("moment/locale/ru")

export default moment
